/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Platforms_DetailInputs */

const en_common_header_explore_platforms_detail = /** @type {(inputs: Common_Header_Explore_Platforms_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web, API, CLI, and mobile`)
};

const zh_common_header_explore_platforms_detail = /** @type {(inputs: Common_Header_Explore_Platforms_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web、API、CLI 与移动端`)
};

/**
* | output |
* | --- |
* | "Web, API, CLI, and mobile" |
*
* @param {Common_Header_Explore_Platforms_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_platforms_detail = /** @type {((inputs?: Common_Header_Explore_Platforms_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Platforms_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_platforms_detail(inputs)
	return zh_common_header_explore_platforms_detail(inputs)
});
export { common_header_explore_platforms_detail as "common.header.explore.platforms.detail" }